/* Self-contained Shopify section. No dependencies or animation library. */
if (!customElements.get('shz-life-moments')) {
  customElements.define('shz-life-moments', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.button = this.querySelector('.shz-moments-toggle');
      const group = this.querySelector('.shz-moments-group');
      if (this.dataset.autoplay !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches || window.Shopify?.designMode || group.children.length < 3) return;
      const copy = group.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      copy.inert = true;
      copy.querySelectorAll('[data-shopify-editor-block]').forEach(el => el.removeAttribute('data-shopify-editor-block'));
      group.after(copy);
      this.classList.add('is-ready');
      this.button.hidden = false;
      this.button.addEventListener('click', () => {
        const paused = this.classList.toggle('is-paused');
        this.button.setAttribute('aria-pressed', String(paused));
        this.button.textContent = paused ? 'Play motion' : 'Pause motion';
      });
      this.observer = new IntersectionObserver(entries => this.classList.toggle('is-visible', entries[0].isIntersecting), {rootMargin: '80px'});
      this.observer.observe(this);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}
